import { Button, Row,  Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import UserEmailDetailsPage from './userEmailDetails';
import UserPositionDetailsPage from './userCategoryDetails';
import React, { useEffect, useState } from 'react';
import ProfileInfoImage01 from '../../assets/images/profileInfo1.png';
import ProfileInfoImage02 from '../../assets/images/profileInfo2.png';
import ProfileInfoImage03 from '../../assets/images/profileInfo3.png';
import ProfileInfoImage04 from '../../assets/images/profileInfo4.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faForward } from '@fortawesome/pro-solid-svg-icons';
import './scss/profileInfoModal.scss';
import {
  useGetProfileCategoriesQuery,
  useUpdateProfileInformationMutation
} from '../../features/componentEndpoints/profileInformationEndpoints';
import PropTypes from 'prop-types';
import Modal from '../../components/Modal/index';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import ConfirmationModal from '../../components/ConfirmationPopUp';
import ProfileInfoConfirm from '../../assets/images/profileInfoConfirm.png';
import { useDashboardContext } from '../dashboard/context';

const ProfileInfoComponent = ({
  isOpen,
  onClose,
  profileData
}) => {
  const [profilePageNumber, setProfilePageNumber] = useState(0);
  const { data: categoriesData, isSuccess: categoriesSuccess } = useGetProfileCategoriesQuery();
  const [updateProfile] = useUpdateProfileInformationMutation();
  const dashboardContext = useDashboardContext();

  const [profileCategories, setProfileCategories] = useState([]);
  const [otherPosition, setOtherPosition] = useState('');
  const [otherCourse, setOtherCourse] = useState('');
  const [primaryEmail, setPrimaryEmail] = useState('');
  const [secondaryEmail, setSecondaryEmail] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState();
  const [showConfirmModel, setShowConfirmModel] = useState(false);

  const profileImages = [
    ProfileInfoImage01,
    ProfileInfoImage02,
    ProfileInfoImage03,
    ProfileInfoImage04
  ];

  const profilePages = [
    <UserEmailDetailsPage
      key="emailPage"
      primaryEmail={primaryEmail}
      secondaryEmail={secondaryEmail}
      onPrimaryEmailChange={setPrimaryEmail}
      onSecondayEmailChange={setSecondaryEmail}
    />,
    <UserPositionDetailsPage
      key="positionCategories"
      profileData={profileCategories}
      categoryData={categoriesData && categoriesData.positionCategories}
      handleChecked={handleChecked}
      setProfileCategories={setProfileCategories}
      otherOptionValue={otherPosition}
      setOtherValue={setOtherPosition}
      title={'Position'}
    />,
    <UserPositionDetailsPage
      key="graveCategories"
      profileData={profileCategories}
      categoryData={categoriesData && categoriesData.gradeLevelCategories}
      handleChecked={handleChecked}
      setProfileCategories={setProfileCategories}
      title={'Check all applicable grade ranges you teach/support'}
    />,
    <UserPositionDetailsPage
      key="courseCategories"
      profileData={profileCategories}
      categoryData={categoriesData && categoriesData.courseCategories}
      handleChecked={handleChecked}
      otherOptionValue={otherCourse}
      setOtherValue={setOtherCourse}
      setProfileCategories={setProfileCategories}
      title={'Choose all content you teach/support/direct '}
    />
  ];

  useEffect(() => {
    if (categoriesSuccess && profileData) {
      setProfileCategories(profileData.profileCategories);
      setOtherPosition(profileData.otherPosition);
      setOtherCourse(profileData.otherCourse);
      setPrimaryEmail(profileData.primaryEmail);
      setSecondaryEmail(profileData.secondaryEmail);
      setIsLoading(false);
    }
  }, [categoriesSuccess]);

  function handleChecked(e) {
    if (e.target.checked) {
      setProfileCategories((result) => [...result, parseInt(e.target.id.split('category_')[1])]);
    } else {
      setProfileCategories(
        profileCategories.filter(function (category) {
          return category != e.target.id.split('category_')[1];
        })
      );
    }
  }

  async function  handleConfirmModel (e) {
    e?.preventDefault();
    if (profilePageNumber < profilePages.length - 1) {
      setProfilePageNumber(profilePageNumber + 1);
    } else {
      setError('');
      setShowConfirmModel(true);
    }
  }

  async function handleSubmit() {    
    try {
      const formData = new FormData();
      formData.append('primaryEmail', primaryEmail);
      formData.append('secondaryEmail', secondaryEmail);
      formData.append('otherPosition', otherPosition);
      formData.append('otherCourse', otherCourse);     

      profileCategories.forEach((profileCategory, index) => {
        formData.append(`profileCategories[${index}]`, profileCategory);
      });
      await updateProfile(formData).unwrap();
      onClose();
      dashboardContext.setProfileUpdateSuccess(true);
    } catch (ex) {
      console.log(ex);

      if (!ex?.status || ex.status === 'FETCH_ERROR') {
        setError('No server response');
      } else {
        setError('Something went wrong, could not update profile information');
      }
    }
  }

  return (
    <>
      {!isLoading && (
        <Modal
          isOpen={isOpen}
          onClose={onClose}
          contentWidth='85%'
          hideHeader={true}
          modalClassName='p-0 model-overflow'
          disableBackdropClose={true}
        >
          <Form onSubmit={handleConfirmModel}>
            <Row>
              <Col className="col-5">
                <div className='leftPane position-absolute px-5 py-5'>
                  <Row style={{ fontWeight: '300' }}>Confirm</Row>
                  <Row style={{ fontWeight: '800' }}>Profile Information</Row>
                
                  <Row className="d-flex flex-row">
                    {Array.from({ length: 4 }, (_, i) => (
                      <div className="square" key={'square' + i}></div>
                    ))}
                  </Row>
                </div>
                <Row className="position-absolute progress-seek pb-5">
                  {Array.from({ length: profilePages.length }, (_, i) => (
                    <button
                      onClick={(e) =>
                        e.target.form.checkValidity()
                          ? setProfilePageNumber(i - 1)
                          : e.target.form.reportValidity()
                      }
                      className={profilePageNumber == i ? 'oval' : 'progress-circle'}
                      key={'profilePage' + i}
                    />
                  ))}
                </Row>
                <img src={profileImages.at(profilePageNumber)} alt="Profile background" loading="lazy" className="h-100 w-100"/>
              </Col>
              <div className="modalBody col-7">
                <div className="d-flex flex-row justify-content-between mb-3">
                  <div className='fs-18 text-black'>Professional Profile Update
                    {profilePageNumber == 0 &&
                    <OverlayTrigger
                      key="assignedVia"
                      placement="right"
                      overlay={<Tooltip className="tooltip-white"><p className='mb-0'>We want to keep you in the loop with the latest and <br/>greatest info for your grade level and position. Help us <br/>out by filling out this quick profile survey! <br/><br/>And don&apos;t worry, your info is safe with us – we never <br/>share it with anyone else.</p></Tooltip>}>
                      <FontAwesomeIcon icon={faCircleQuestion} className="circle-question mx-1" />
                    </OverlayTrigger>
                    }
                  </div>
                  <div
                    className="d-flex flex-row align-items-center"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      onClose();
                    }}>
                    <span style={{ color: '#F7931E', marginRight: '5px' }}>Fill Later</span>
                    <FontAwesomeIcon icon={faForward} color={'#F7931E'} />
                  </div>
                </div>
                <Row>{profilePages.at(profilePageNumber)}</Row>
                <div className="d-flex flex-row justify-content-end flex-fill align-items-end mb-4">
                  {profilePageNumber > 0 && (
                    <Button
                      className="navigationButtons"
                      onClick={() => setProfilePageNumber(profilePageNumber - 1)}
                      variant="castleWhite">
                          Previous
                    </Button>
                  )}
                  <Button
                    type="submit"
                    className="navigationButtons"
                    style={{ marginLeft: '12px' }}
                    variant="castleRed">
                    {profilePageNumber < profilePages.length - 1 ? 'Next' : 'Submit'}
                  </Button>
                </div>
                {error && (
                  <div style={{ color: '#F84646', textAlign: 'right', marginTop: '10px' }}>
                    {error}
                  </div>
                )}
              </div>
            </Row>
          </Form>
        </Modal>
      )}
      <ConfirmationModal
        isOpen={showConfirmModel}
        onClose={() => setShowConfirmModel(false)}
        onSave={() => handleSubmit()}
        contentWidth={'50%'}
        buttonPosition={'center'}
        content={`<p class='fw-normal fs-18'>Are you sure your settings are correct?</p> ${profileCategories?.length > 0 ? '': 
          '<div class=\'fs-14\'>Warning: You did not select any categories. If you don&apos;t select any categories, you will not be notified <br/> of any messages pertaining to any of these categories.</div>' }`}
        isRawHtmlContent={true}
        cancelButton={'No'}
        confirmButton={'Yes'}
        showIcon={true}
        icon={ProfileInfoConfirm}
      />
    </>
  );
};

ProfileInfoComponent.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  profileData: PropTypes.object,
  setSuccessNotification: PropTypes.func,
};

export default ProfileInfoComponent;
